export default "__VITE_ASSET__BfInmkgp__"